<template>
  <div class="page">
    <div class="container">
      <div class="page__row">
        <div class="page__inner">
          <h1 class="title title_red page__title">Collaboration</h1>
          <p class="lead page__lead" style="margin-bottom: auto">By integrating all areas of the communications industry, through people, knowledge, technologies, connections, brands, and ideas, we create quality for the client, for ourselves, and for the market as a whole</p>
        </div>
      </div>
    </div>

    <missionSvg />

    <page-footer
      :prev="{ name: 'creation-en' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import missionSvg from '@/components/missionSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'partnership-en',
  mixins: [RouteMixin],
  components: {
    missionSvg,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.partnership-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__title', 0.3, { y: '-30px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__lead', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__title', 0.3, { y: '30px', opacity: 0 }))
      .add(TweenMax.to('.partnership-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
